module.exports = __webpack_public_path__ + "img/accounting.ba1303dc.png";